function appendCoffeMachine() {
    let coffeeMachine = document.createElement('div');
    let subscriptionCartListItem = document.querySelector('.as-variant');
    let productId = "macchina-caffe-capsule-abbonamento";

    const translations = {
        en: {
            machineTitle: "Coffee Machine (one-time)",
        },
        it: {
            machineTitle: "Macchina del caffè (una tantum)",
        }
    };

    coffeeMachine.innerHTML = subscriptionCartListItem.outerHTML;
    coffeeMachine.style.marginBottom = '24px';
    fetch(`${window.Shopify.routes.root}products/${productId}.js`)
        .then(response => response.json())
        .then(product => {
            function formatPrice(price) {
                let priceInDollars = price / 100;
                let formattedValue = new Intl.NumberFormat('it-IT', { minimumFractionDigits: 2 }).format(priceInDollars);
                let currencySymbol = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' })
                    .formatToParts(price)
                    .find(part => part.type === 'currency').value;
                return `${currencySymbol}${formattedValue}`;
            }

            let comparedPriceElement = coffeeMachine.querySelector('.as-review-bundle-compare-price');
            if (comparedPriceElement) {
                comparedPriceElement.textContent = formatPrice(product.price);
            }
            let priceElement = coffeeMachine.querySelector('.as-review-bundle-sale-price');
            if (priceElement) {
                priceElement.textContent = formatPrice(product.compare_at_price);
            }
            let titleElement = coffeeMachine.querySelector('.as-review-bundle-title');
            if (titleElement) {
                titleElement.textContent = unaTantumMachineTitle;
            }
            let imageElement = coffeeMachine.querySelector('.as-image');
            if (imageElement) {
                imageElement.src = product.images[0];
            }
            
        })
        .catch(error => console.error('Errore:', error));

    subscriptionCartListItem.querySelector('.as-review-bundle-compare-price').style.textDecoration = 'none';
    subscriptionCartListItem.querySelector('.as-review-bundle-compare-price').style.marginLeft = '0';
    subscriptionCartListItem.querySelector('.as-review-bundle-sale-price').style.display = 'none';

    subscriptionCartListItem.parentElement.prepend(coffeeMachine);
}

function customizeProductCard(productCard) {
    const productCardMachineIncluded = productCard.querySelector('.as-display-text');
    const productCardFullPrice = productCard.querySelector('.as-price');
    productCardMachineIncluded.dataset.after = machineIncluded;
    productCardFullPrice.dataset.after = fromSecondOrder;
    productCardFullPrice.dataset.before = firstOrder;
}

const observer = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
        mutation.addedNodes.forEach(node => {

            // Funzione per controllare ricorsivamente i nodi figli
            const checkNodeAndChildren = (currentNode) => {
                if (currentNode.classList) {
                    if (currentNode.classList.contains('as-bab-product')) {
                        customizeProductCard(currentNode);
                        return;
                    } else if (currentNode.classList.contains('as-review-bundle-compare-price')) {
                        appendCoffeMachine();
                        observer.disconnect();
                        return;
                    }
                }
                // Scansiona i figli di questo nodo
                currentNode.childNodes.forEach(childNode => {
                    checkNodeAndChildren(childNode);
                });
            };

            // Controlla il nodo corrente e i suoi figli
            checkNodeAndChildren(node);
        });
    }
});

observer.observe(document, { childList: true, subtree: true });
